import { detectDomainTitle } from './detectDomain';

export default function pageTitle(title: string): string {
  return `${detectDomainTitle() || ''} ${title} - Xpanse`;
}
